/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/play';
import { PLAY } from '@/store/types';
import { finalizeAction } from '@/store/actions';
import { PlayOrder } from '@/api/types/play';

export interface StorePlayOrderListState {
  filter: string;
  limit: number;
  list: PlayOrder[];
  extra: {
    pendingConsume: number;
    pendingService: number;
    filter: string;
  };
  nextPoint: number;
  loading: boolean;
  noMore: boolean;
}

export default {
  namespaced: true,
  state: {
    filter: null,
    limit: 10,
    list: [],
    extra: {},
    nextPoint: null,
    loading: false,
    noMore: false,
  },
  getters: {},
  actions: {
    [PLAY.GET_ORDER_LIST]({ state, commit }, { filter, action: rawAction }) {
      const action = finalizeAction(rawAction, state.filter === filter, state.noMore);
      if (action && !state.loading) {
        commit(PLAY.GET_ORDER_LIST, { status: 'start' });
        const nextPoint = action === 'reload' ? null : state.nextPoint;
        return new Promise((resolve, reject) => {
          api.getOrderList(filter, nextPoint, state.limit).then((res) => {
            commit(PLAY.GET_ORDER_LIST, {
              status: 'success',
              filter,
              action,
              fetch,
              data: res.data,
              extra: res.extra,
            });
            resolve();
          }).catch(() => {
            commit(PLAY.GET_ORDER_LIST, { status: 'failure' });
            reject();
          });
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [PLAY.GET_ORDER_LIST](state, { status, filter, action, data, extra }) {
      if (status === 'start') {
        state.loading = true;
      } else {
        if (status === 'success') {
          state.filter = filter;
          if (action === 'reload') { // 刷新列表
            state.list = data;
          } else if (action === 'more') { // 获取更多
            state.list = state.list.concat(data);
          } else if (action === 'fetch') { // 获取最新部分
            state.list = data.concat(state.list.filter(p => !data.some(q => q.id === p.id)));
          }
          state.extra = extra;
          state.noMore = !extra.nextPoint;
          state.nextPoint = extra.nextPoint;
        }
        state.loading = false;
      }
    },
    [PLAY.UPDATE_ORDER](state, { id, order = null }) {
      const index = state.list.findIndex(p => p.id === id);
      if (index !== -1) {
        if (order) {
          state.list[index] = order;
        } else {
          state.list.splice(index, 1);
        }
      }
    },
  },
};
